/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateProjectShareSessionDto } from '../models/work-create-project-share-session-dto';
import { WorkProjectSharePublicDossierContentDto } from '../models/work-project-share-public-dossier-content-dto';
import { WorkProjectSharePublicDossierDto } from '../models/work-project-share-public-dossier-dto';
import { WorkProjectSharePublicInfoDto } from '../models/work-project-share-public-info-dto';
import { WorkProjectSharePublicProjectDto } from '../models/work-project-share-public-project-dto';
import { WorkProjectSharePublicSwitcherEntryDto } from '../models/work-project-share-public-switcher-entry-dto';
import { WorkProjectSharePublicUploadResultDto } from '../models/work-project-share-public-upload-result-dto';
import { WorkProjectShareSessionDto } from '../models/work-project-share-session-dto';

@Injectable({ providedIn: 'root' })
export class WorkProjectSharesPublicV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `projectSharesPublicV2ControllerGetInfo()` */
  static readonly ProjectSharesPublicV2ControllerGetInfoPath = '/v2/project-shares/public/info';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectSharesPublicV2ControllerGetInfo()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectSharesPublicV2ControllerGetInfo$Response(
    params: {
      token: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProjectSharePublicInfoDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectSharesPublicV2Service.ProjectSharesPublicV2ControllerGetInfoPath, 'get');
    if (params) {
      rb.query('token', params.token, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProjectSharePublicInfoDto>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectSharesPublicV2ControllerGetInfo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectSharesPublicV2ControllerGetInfo(
    params: {
      token: string;
    },
    context?: HttpContext
  ): Observable<WorkProjectSharePublicInfoDto> {
    return this.projectSharesPublicV2ControllerGetInfo$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProjectSharePublicInfoDto>): WorkProjectSharePublicInfoDto => r.body)
    );
  }

  /** Path part for operation `projectSharesPublicV2ControllerCreateSession()` */
  static readonly ProjectSharesPublicV2ControllerCreateSessionPath = '/v2/project-shares/public/session';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectSharesPublicV2ControllerCreateSession()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectSharesPublicV2ControllerCreateSession$Response(
    params: {
      body: WorkCreateProjectShareSessionDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProjectShareSessionDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectSharesPublicV2Service.ProjectSharesPublicV2ControllerCreateSessionPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProjectShareSessionDto>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectSharesPublicV2ControllerCreateSession$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectSharesPublicV2ControllerCreateSession(
    params: {
      body: WorkCreateProjectShareSessionDto
    },
    context?: HttpContext
  ): Observable<WorkProjectShareSessionDto> {
    return this.projectSharesPublicV2ControllerCreateSession$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProjectShareSessionDto>): WorkProjectShareSessionDto => r.body)
    );
  }

  /** Path part for operation `projectSharesPublicV2ControllerGetShares()` */
  static readonly ProjectSharesPublicV2ControllerGetSharesPath = '/v2/project-shares/public/shares';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectSharesPublicV2ControllerGetShares()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectSharesPublicV2ControllerGetShares$Response(
    params: {
      'x-share-session': string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkProjectSharePublicSwitcherEntryDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectSharesPublicV2Service.ProjectSharesPublicV2ControllerGetSharesPath, 'get');
    if (params) {
      rb.header('x-share-session', params['x-share-session'], {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkProjectSharePublicSwitcherEntryDto>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectSharesPublicV2ControllerGetShares$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectSharesPublicV2ControllerGetShares(
    params: {
      'x-share-session': string;
    },
    context?: HttpContext
  ): Observable<Array<WorkProjectSharePublicSwitcherEntryDto>> {
    return this.projectSharesPublicV2ControllerGetShares$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkProjectSharePublicSwitcherEntryDto>>): Array<WorkProjectSharePublicSwitcherEntryDto> => r.body)
    );
  }

  /** Path part for operation `projectSharesPublicV2ControllerGetProject()` */
  static readonly ProjectSharesPublicV2ControllerGetProjectPath = '/v2/project-shares/public/project';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectSharesPublicV2ControllerGetProject()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectSharesPublicV2ControllerGetProject$Response(
    params: {
      shareId?: number;
      'x-share-session': string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProjectSharePublicProjectDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectSharesPublicV2Service.ProjectSharesPublicV2ControllerGetProjectPath, 'get');
    if (params) {
      rb.query('shareId', params.shareId, {});
      rb.header('x-share-session', params['x-share-session'], {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProjectSharePublicProjectDto>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectSharesPublicV2ControllerGetProject$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectSharesPublicV2ControllerGetProject(
    params: {
      shareId?: number;
      'x-share-session': string;
    },
    context?: HttpContext
  ): Observable<WorkProjectSharePublicProjectDto> {
    return this.projectSharesPublicV2ControllerGetProject$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProjectSharePublicProjectDto>): WorkProjectSharePublicProjectDto => r.body)
    );
  }

  /** Path part for operation `projectSharesPublicV2ControllerGetDossiers()` */
  static readonly ProjectSharesPublicV2ControllerGetDossiersPath = '/v2/project-shares/public/dossiers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectSharesPublicV2ControllerGetDossiers()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectSharesPublicV2ControllerGetDossiers$Response(
    params: {
      shareId?: number;
      'x-share-session': string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkProjectSharePublicDossierDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectSharesPublicV2Service.ProjectSharesPublicV2ControllerGetDossiersPath, 'get');
    if (params) {
      rb.query('shareId', params.shareId, {});
      rb.header('x-share-session', params['x-share-session'], {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkProjectSharePublicDossierDto>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectSharesPublicV2ControllerGetDossiers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectSharesPublicV2ControllerGetDossiers(
    params: {
      shareId?: number;
      'x-share-session': string;
    },
    context?: HttpContext
  ): Observable<Array<WorkProjectSharePublicDossierDto>> {
    return this.projectSharesPublicV2ControllerGetDossiers$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkProjectSharePublicDossierDto>>): Array<WorkProjectSharePublicDossierDto> => r.body)
    );
  }

  /** Path part for operation `projectSharesPublicV2ControllerGetDossierContent()` */
  static readonly ProjectSharesPublicV2ControllerGetDossierContentPath = '/v2/project-shares/public/dossiers/{kind}/{id}/content';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectSharesPublicV2ControllerGetDossierContent()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectSharesPublicV2ControllerGetDossierContent$Response(
    params: {
      kind: string;
      id: number;
      shareId?: number;
      'x-share-session': string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProjectSharePublicDossierContentDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectSharesPublicV2Service.ProjectSharesPublicV2ControllerGetDossierContentPath, 'get');
    if (params) {
      rb.path('kind', params.kind, {});
      rb.path('id', params.id, {});
      rb.query('shareId', params.shareId, {});
      rb.header('x-share-session', params['x-share-session'], {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProjectSharePublicDossierContentDto>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectSharesPublicV2ControllerGetDossierContent$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectSharesPublicV2ControllerGetDossierContent(
    params: {
      kind: string;
      id: number;
      shareId?: number;
      'x-share-session': string;
    },
    context?: HttpContext
  ): Observable<WorkProjectSharePublicDossierContentDto> {
    return this.projectSharesPublicV2ControllerGetDossierContent$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProjectSharePublicDossierContentDto>): WorkProjectSharePublicDossierContentDto => r.body)
    );
  }

  /** Path part for operation `projectSharesPublicV2ControllerUploadPhoto()` */
  static readonly ProjectSharesPublicV2ControllerUploadPhotoPath = '/v2/project-shares/public/uploads/photo';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectSharesPublicV2ControllerUploadPhoto()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectSharesPublicV2ControllerUploadPhoto$Response(
    params: {
      shareId?: number;
      'x-share-session': string;
      body: {
'file': Blob;
}
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProjectSharePublicUploadResultDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectSharesPublicV2Service.ProjectSharesPublicV2ControllerUploadPhotoPath, 'post');
    if (params) {
      rb.query('shareId', params.shareId, {});
      rb.header('x-share-session', params['x-share-session'], {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProjectSharePublicUploadResultDto>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectSharesPublicV2ControllerUploadPhoto$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectSharesPublicV2ControllerUploadPhoto(
    params: {
      shareId?: number;
      'x-share-session': string;
      body: {
'file': Blob;
}
    },
    context?: HttpContext
  ): Observable<WorkProjectSharePublicUploadResultDto> {
    return this.projectSharesPublicV2ControllerUploadPhoto$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProjectSharePublicUploadResultDto>): WorkProjectSharePublicUploadResultDto => r.body)
    );
  }

  /** Path part for operation `projectSharesPublicV2ControllerUploadDocument()` */
  static readonly ProjectSharesPublicV2ControllerUploadDocumentPath = '/v2/project-shares/public/uploads/document';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectSharesPublicV2ControllerUploadDocument()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectSharesPublicV2ControllerUploadDocument$Response(
    params: {
      shareId?: number;
      'x-share-session': string;
      body: {
'file': Blob;
}
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProjectSharePublicUploadResultDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectSharesPublicV2Service.ProjectSharesPublicV2ControllerUploadDocumentPath, 'post');
    if (params) {
      rb.query('shareId', params.shareId, {});
      rb.header('x-share-session', params['x-share-session'], {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProjectSharePublicUploadResultDto>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectSharesPublicV2ControllerUploadDocument$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectSharesPublicV2ControllerUploadDocument(
    params: {
      shareId?: number;
      'x-share-session': string;
      body: {
'file': Blob;
}
    },
    context?: HttpContext
  ): Observable<WorkProjectSharePublicUploadResultDto> {
    return this.projectSharesPublicV2ControllerUploadDocument$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProjectSharePublicUploadResultDto>): WorkProjectSharePublicUploadResultDto => r.body)
    );
  }

  /** Path part for operation `projectSharesPublicV2ControllerUploadScan()` */
  static readonly ProjectSharesPublicV2ControllerUploadScanPath = '/v2/project-shares/public/uploads/scan';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectSharesPublicV2ControllerUploadScan()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectSharesPublicV2ControllerUploadScan$Response(
    params: {
      shareId?: number;
      'x-share-session': string;
      body: {
'pages': Array<Blob>;
}
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProjectSharePublicUploadResultDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectSharesPublicV2Service.ProjectSharesPublicV2ControllerUploadScanPath, 'post');
    if (params) {
      rb.query('shareId', params.shareId, {});
      rb.header('x-share-session', params['x-share-session'], {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProjectSharePublicUploadResultDto>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectSharesPublicV2ControllerUploadScan$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectSharesPublicV2ControllerUploadScan(
    params: {
      shareId?: number;
      'x-share-session': string;
      body: {
'pages': Array<Blob>;
}
    },
    context?: HttpContext
  ): Observable<WorkProjectSharePublicUploadResultDto> {
    return this.projectSharesPublicV2ControllerUploadScan$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProjectSharePublicUploadResultDto>): WorkProjectSharePublicUploadResultDto => r.body)
    );
  }

}
